import {AfterViewInit, EventEmitter, Component, Injector, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ConditionOperator, Filter} from "../../../ngx-types";
import {NgxFilterBase} from "../../ngx-filter-base";

@Component({
  selector: 'ngx-conditions-selector-filter',
  templateUrl: '../../ngx-filter-single-template-base.html'
})
export class NgxConditionsSelectorFilterComponent extends NgxFilterBase implements OnInit, OnDestroy, AfterViewInit {
  constructor(injector: Injector) {
    super(injector);
  }

  get Label1(): string {
    return (this.filterService.translator?.conditionLabel) ? this.filterService.translator.conditionLabel : 'condition';
  }

  Label2: string;
  @Input() filter: Filter;
  @Input() conditions: { key: ConditionOperator, label: string }[] = [];
  @Output() changeValue = new EventEmitter<any>();

  ngAfterViewInit(): void {
    this.generateComponents(this.filterService.filtersComponent.conditionSelector, this.filterService.translator, this.conditions);
  }
}
